export default {"src":"/_next/static/media/mo.6e16209f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};